require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-why-do-the-private-sector-arms-of-the-mdbs-fund-pr.json") })
        }
      }, "path---en-us-update-why-do-the-private-sector-arms-of-the-mdbs-fund-pr");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-why-do-the-private-sector-arms-of-the-mdbs-fund-pr!./.cache/json/en-us-update-why-do-the-private-sector-arms-of-the-mdbs-fund-pr.json
// module id = 863
// module chunks = 231608221292675